/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import { Link } from 'react-router-dom';
import moment from 'moment-timezone';

import TopBar from '../../../components/TopBar'
import { DataTableList } from '../../../components/DataTable/DataTableList';
import DeleteConfirmationPopup from '../../../components/DeleteConfirmationPopup';
import { deleteProducts, getCategoryBrand, getProducts, getProductsWithDetail } from '../../../api/productsApi';

import Delete from "../../../assets/images/delete.svg";
import penIcon from "../../../assets/images/pen-img.svg";
import down from "../../../assets/images/icondropdown.svg";
import searchIcon from "../../../assets/images/icon-search.svg";
import { exportToCSV } from "../../../utils/functions";

import styles from '../page.module.css'

const AllProducts = () => {


  const popupRef = useRef()
  const dropdownRef = useRef()
  const brandDropdownRef = useRef()

  const [productList, setProductList] = useState([])
  const [isLoadingData, setIsLoadingData] = useState(false);
  const [isExportLoading, setIsExportLoading] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [isAllSelected, setIsAllSelected] = useState(false);
  const [columnWidths, setColumnWidths] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [toggleSelect, setToggleSelect] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);

  // Dropdown states
  const [open, setOpen] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [openBrand, setOpenBrand] = useState(false);
  const [selectedBrands, setSelectedBrands] = useState([]);

  const [searchInput, setSearchInput] = useState('');
  const [categoryList, setCategoryList] = useState([])
  const [brandList, setBrandList] = useState([])
  // Categories list
  const fetchCategoryBrand = async () => {
    try {
      const response = await getCategoryBrand()
      if (response?.success) {
        setCategoryList(response?.data?.categories)
        setBrandList(response?.data?.brands)
      }
    } catch (error) {
      console.log({ error })
    }
  }

  useEffect(() => {
    fetchCategoryBrand()
  }, [])

  const fetchData = async () => {
    try {
      setIsLoadingData(true);
      const response = await getProducts({
        page: currentPage,
        search: searchInput,
        sortBy: 'createdAt',
        category: selectedCategories?.map(item => item?.id).join(','),
        brand: selectedBrands?.map(item => item?.id).join(','),
      });

      if (response?.data?.result?.length <= 0) {
        setIsLoadingData(false);
      }
      console.log({ first: response?.data?.result })
      setProductList(response?.data?.result || []);
      setTotalPage(response?.data?.totalPages || 1);
    } catch (error) {
      console.error('Error loading pages:', error);
      setIsLoadingData(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [currentPage, selectedCategories, selectedBrands]);


  useEffect(() => {
    const handleClickOutside = (event) => {

      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowDeletePopup(false);
      }
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
      if (brandDropdownRef.current && !brandDropdownRef.current.contains(event.target)) {
        setOpenBrand(false);
      }
    };

    // Attach the event listener when the component mounts
    document.addEventListener("mousedown", handleClickOutside);

    // Detach the event listener when the component unmounts
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const calculateColumnWidths = async () => {
    return new Promise((resolve) => {
      const tempWidths = productList?.reduce((acc, row) => {
        Object.keys(row).forEach((key) => {
          const dataValue = row[key]?.toString();
          const title = row[key];

          let maxContentLength = Math.max(dataValue?.length, title?.length);

          if (!acc[key] || maxContentLength > acc[key]) {
            acc[key] = maxContentLength;
          }
        });
        return acc;
      }, {});

      if (tempWidths !== undefined) {
        const widthMap = Object.keys(tempWidths).reduce((acc, key) => {
          acc[key] = `${tempWidths[key] * 10 + 40}px`;
          return acc;
        }, {});
        setColumnWidths(widthMap);
      }
      resolve();
    });
  };

  useEffect(() => {
    if (productList?.length > 0) {
      calculateColumnWidths();
    }
  }, [productList]);

  useEffect(() => {
    if (Object.keys(columnWidths).length > 0) {
      setTimeout(() => {
        setIsLoadingData(false);
      }, 1000);
    }
  }, [columnWidths]);

  const handleCategoryChange = (category) => {
    setSelectedCategories(prev => {
      if (prev.includes(category)) {
        const filtered = prev.filter(c => c !== category);
        return filtered.length === 0 ? [] : filtered;
      } else {
        return prev?.length === 0
          ? [category]
          : [...prev, category];
      }
    });
  }

  const handleBrandChange = (brand) => {
    setSelectedBrands(prev => {
      if (prev.includes(brand)) {
        const filtered = prev.filter(b => b !== brand);
        return filtered.length === 0 ? [] : filtered;
      } else {
        return prev?.length === 0 ? [brand] : [...prev, brand];
      }
    });
  };


  const handleMasterCheckboxChange = () => {
    if (isAllSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(productList?.map((row) => row?.productId));
    }
    setIsAllSelected(!isAllSelected);
  };

  const columns = [
    {
      name: 'Title',
      selector: (row) => row?.title,
      cell: (row) => <div className='editTitle'><Link to={`/product/${row?.productId}`}>{row.title}</Link></div>,
      sortable: true,
      minWidth: columnWidths['title'] ? `${parseInt(columnWidths['title']) + 50}px` : '200px',
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px", color: '#000' },

    },
    {
      name: 'SKU',
      selector: (row) => row?.sku,
      cell: (row) => <div>{row?.sku}</div>,
      sortable: true,
      width: `${parseInt(columnWidths['sku']) + 30}px` || '150px',
      style: { width: `${parseInt(columnWidths['sku']) + 30}px` || '150px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
    },
    {
      name: 'Price From',
      selector: (row) => row?.priceFrom,
      cell: (row) => <div>₹{row?.priceFrom}</div>,
      sortable: true,
      width: '130px',
      style: { width: '130px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
    },
    {
      name: 'Price To',
      selector: (row) => row?.priceTo,
      cell: (row) => <div>₹{row?.priceTo}</div>,
      sortable: true,
      width: '130px',
      style: { width: '130px', paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
    },
    {
      name: 'Status',
      selector: (row) => row?.status,
      cell: (row) => (
        <span className={`status-badge ${row.status}`}>
          {row?.status?.charAt(0).toUpperCase() + row?.status?.slice(1)}
        </span>
      ),
      sortable: true,
      width: '150px',
      style: { paddingLeft: 0, paddingRight: "16px", paddingTop: "15px", paddingBottom: "15px", fontSize: "14px" },
    },
    {
      name: 'Date',
      selector: (row) => row?.createdAt,
      cell: (row) => <div>{moment(row.createdAt).tz("Asia/Kolkata").format("MMM DD, YYYY")}</div>,
      sortable: true,
      width: columnWidths['createdAt'] ? `${parseInt(columnWidths['createdAt']) - 130}px` : '200px',
      style: { width: columnWidths['createdAt'] ? `${parseInt(columnWidths['createdAt']) - 130}px` : '200px', paddingTop: "15px", paddingBottom: "15px", fontSize: "14px", paddingLeft: 0 },
    },
    {
      name: "Actions",
      cell: (row) => (
        <div className="action-buttons">
          <Link to={`/product/${row?.productId}`}><button className="edit-btn"><img src={penIcon} alt="pen-icon" /></button></Link>
          <button className="delete-btn" onClick={() => {
            setDeleteTarget({ type: "single", row });
            setShowDeletePopup(true);
          }}><img src={Delete} alt="delete-icon" /></button>
        </div>
      ),
      width: "90px"
    }
  ];

  const customStyles = {
    headCells: {
      style: {
        fontWeight: 500,
        fontSize: '14px',
      },
    },
  };

  const confirmDelete = async () => {
    if (!deleteTarget) return;

    try {
      if (deleteTarget.type === "single") {
        const response = await deleteProducts([deleteTarget?.row?.productId]);
        if (response?.success) {
          await fetchData()
        }
      }

      if (deleteTarget.type === "multiple") {
        const response = await deleteProducts(deleteTarget?.rows);
        if (response?.success) {
          await fetchData()
        }
      }
    } catch (error) {
      console.log('Error deleting pages:', error);
      // Handle error (show notification, etc.)
    }
    setSelectedRows([]);
    setIsAllSelected(false);
    setToggleSelect(prev => !prev);

    setShowDeletePopup(false);
    setDeleteTarget(null);
  };

  const handleSearch = async () => {
    fetchData();
  }

  function convertToSlug(str) {
    let slug = str.toLowerCase();

    slug = slug.trim();

    slug = slug.replace(/[^a-z0-9\s-]/g, '');

    slug = slug.replace(/\s+/g, '-');

    return slug;
  }

  const handleExportAllCSV = async () => {
    try {
      setIsExportLoading(true);

      const response = await getProductsWithDetail();
      const allData = response?.data || [];

      const columns = [
        { name: 'Title', selector: (row) => row?.title },
        { name: 'Slug', selector: (row) => row?.slug ? row?.slug : convertToSlug(row?.title), },
        { name: 'SKU', selector: (row) => row?.sku },
        { name: 'Price From', selector: (row) => row?.priceFrom },
        { name: 'Price To', selector: (row) => row?.priceTo },
        { name: 'Category', selector: (row) => row?.categories?.map((item) => item?.name).join(', ') || '', },
        { name: 'Brand', selector: (row) => row?.brand?.name },
        { name: 'Unit', selector: (row) => row?.unit },
        { name: 'Description', selector: (row) => row?.description },
        { name: 'Short Description', selector: (row) => row?.shortDescription, },
        { name: 'SEO Title', selector: (row) => row?.seoTitle },
        { name: 'SEO Content', selector: (row) => row?.seoContent },
        { name: 'Keyword', selector: (row) => row?.keyword },
        { name: 'Specifications', selector: (row) => row?.specification || '', },
        { name: 'Is Track Stock', selector: (row) => row?.isTrackStock, },
        { name: 'Is Popular', selector: (row) => row?.isPopular, },
        { name: 'Is Hot Deal', selector: (row) => row?.isHotDeal, },
        { name: 'Is Show in List', selector: (row) => row?.isShowInList, },
        { name: 'Is Builder Choice', selector: (row) => row?.isBuilderChoice, },
        { name: 'Is Pro Picks', selector: (row) => row?.isProPicks, },
        { name: 'Is Trending Now', selector: (row) => row?.isTrendingNow, },
        { name: 'Is Service Product', selector: (row) => row?.isServiceProduct, },
        { name: 'Image', selector: (row) => row?.image?.url || '', },
        { name: 'Gallery Image', selector: (row) => row?.galleryImage?.map((item) => item?.url) || '', },
        { name: 'Status', selector: (row) => row?.status },
      ];

      exportToCSV(allData, 'products', columns);
    } catch (error) {
      console.log('Error exporting products:', error);
    } finally {
      setIsExportLoading(false);
    }
  };

  return (
    <div className={`product-list ${styles.productList} ${productList?.length <= 10 && `${styles.productListHeight}`}`}>
      <TopBar />
      <div className={`${styles.productDatatableList}`}>
        <div className={`${styles.productHeader}`}>
          <div className={`${styles.leftSide}`}>
            <div className={`${styles.searchBar}`}>
              <img src={searchIcon} alt="Search" />
              <input
                type="text"
                placeholder="Search by product name or SKU..."
                value={searchInput}
                onChange={(e) => setSearchInput(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
              />
            </div>
            <button className={`${styles.addBtn}`} onClick={() => handleSearch()}>Search</button>
          </div>
          <div className={`${styles.actionButtonsDeleteAdd}`}>
            {categoryList && categoryList.length > 0 &&
              <div className="dropdown-wrapper" ref={dropdownRef}>
                <div className="dropdown-header" onClick={() => setOpen(!open)}>
                  <span className="title">Categories</span>
                  <span className={`arrow ${open ? "rotate" : ""}`}><img src={down} alt='down-icon' /></span>
                </div>
                {open && (
                  <div className="dropdown-list" >
                    {categoryList?.map((cat, index) => (
                      <label key={index}
                        onChange={() => handleCategoryChange(cat)}
                        className="dropdown-item" >
                        <input
                          type="checkbox"
                          checked={selectedCategories.includes(cat)}
                        />
                        <span>{cat?.name}</span>
                      </label>
                    ))}
                  </div>
                )}
              </div>
            }
            
            {brandList && brandList.length > 0 && 
              <div className="dropdown-wrapper" ref={brandDropdownRef}>
                <div className="dropdown-header" onClick={() => setOpenBrand(!openBrand)}>
                  <span className="title">Brands</span>
                  <span className={`arrow ${openBrand ? "rotate" : ""}`}><img src={down} alt='down-icon' /></span>
                </div>

                {openBrand && (
                  <div className="dropdown-list">
                    {brandList?.map((brand, index) => (
                      <label key={index} className="dropdown-item">
                        <input
                          type="checkbox"
                          checked={selectedBrands.includes(brand)}
                          onChange={() => handleBrandChange(brand)}
                        />
                        <span>{brand?.name}</span>
                      </label>
                    ))}
                  </div>
                )}
              </div>
            }

            <Link to='/new-product'><button className={`${styles.addBtn}`}>Add Product</button></Link>

            <button className={`${styles.addBtn} ${styles.exportBtn}`} onClick={handleExportAllCSV}>
              {isExportLoading ? (
                <div className={`ringLoader loaderContinue`}></div>
              ) :
                'Export Products'
              }

            </button>
            {selectedRows?.length > 0 && (
              <div className={`${styles.deleteSelectedBtn}`} onClick={() => {
                setDeleteTarget({ type: "multiple", rows: selectedRows });
                setShowDeletePopup(true);
              }}>
                <img src={Delete} alt="delete-icon" />
              </div>
            )}
          </div>
        </div>

        <div className={`productTable dataTable-list ${productList?.length <= 10 && 'dataTable-border-list'} ${(isLoadingData) ? 'loading-list' : ''} `}>
          <DataTableList
            columns={columns}
            data={productList}
            onSelectedRowsChange={({ selectedRows }) => {
              const selectedIds = selectedRows.map((row) => row.productId);
              setSelectedRows(selectedIds);
              setIsAllSelected(selectedIds.length === productList.length);
            }}
            progressPending={isLoadingData}
            currentPage={currentPage}
            onChangePage={setCurrentPage}
            paginationTotalRows={totalPage}
            selectableRows
            selectAllRows={isAllSelected}
            clearSelectedRows={toggleSelect}
            onSelectAllChange={handleMasterCheckboxChange}
            customStyles={customStyles}
            selectableRowsComponent="input"
            progressComponent={<div className="loader-container"> <div className="loader"></div> </div>}
          // noDataComponent={<NoResultsPublication />}
          />
        </div>
      </div>
      <DeleteConfirmationPopup
        showDeletePopup={showDeletePopup}
        setShowDeletePopup={setShowDeletePopup}
        reference={popupRef}
        title={deleteTarget?.type === "single" ? 'product' : selectedRows?.length === 1 ? 'product' : `products`}
        description={deleteTarget?.type === "single" ? `Are you sure you want to delete ${deleteTarget?.row?.title}?` : selectedRows?.length === 1 ? `Are you sure you want to delete product?` : `Are you sure you want to delete ${selectedRows?.length} products?`}
        confirmDelete={confirmDelete}
      />
    </div>
  )
}

export default AllProducts
